export default [
    {
        path: '/user/group',
        props: true,
        component: () => import('@/views/User/Group'),
    },
];